/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * rebusinession of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */
/**
 * Lambdaへのアクセスのためのドライバーをラップするコード
 * 顧客のメンバー作成
 */

import Logger from '@/utils/logger';
import ErrorMessage from '@/utils/errorMessages';
import { logoutFunc } from './';
import { IResponse, IUserAccount } from '../interfaces';
import * as leanpathDrv from '../leanpathDrv';
// ----ADDITIONAL_IMPORTS----
import generator from 'generate-password-ts';
// ----END-OF-ADDITIONAL_IMPORTS----

/**
 * 顧客のメンバー作成
 * @param userAccount
 * @returns Promise<boolean>
 * @throws {Error} Throws Error object
 */
export const createMemberProc = async (userAccount: IUserAccount): Promise<boolean> => {
  // ----PREPARATION-OF-METHOD----
  const password = generator.generate({
    length: 16,
    numbers: true,
    uppercase: true,
    lowercase: true,
    strict: true,
  });
  // ----END-OF-PREPARATION----

  try {
    const _resp: IResponse = await leanpathDrv.membersHandleCall(true, 'CREATE', userAccount, password);
    if (_resp.success) {
      ErrorMessage.setNoError();
      return true;
    } else {
      ErrorMessage.set(_resp.message, _resp.code);
      Logger.error(_resp.message);
      return false;
    }
  } catch (e) {
    if ((e as Error).toString() === 'Error: refreshToken expired') {
      ErrorMessage.set('refreshトークンの期限が切れたためログアウトします');
      Logger.info('refreshトークンの期限が切れたためログアウトします');
      await logoutFunc();
    }
    ErrorMessage.set((e as Error).toString());
    return false;
  }
};
